<template>
  <ValidationObserver ref="serviceFormObserver" v-slot="{ handleSubmit }">
    <b-form @submit.prevent="handleSubmit(submit)">
      <b-row>
        <b-col xs="12" md="3">
          <h5>Details</h5>
        </b-col>
        <b-col xs="12" md="6">
          <ValidationProvider
            name="name"
            rules="required|min:1"
            v-slot="{ dirty, validated, valid, errors }"
          >
            <b-form-group label="Title">
              <b-form-input
                v-model="model.name"
                :state="dirty || validated ? valid : null"
                required
              ></b-form-input>
              <b-form-invalid-feedback>
                {{ errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </ValidationProvider>
          <b-form-group label="Description">
            <b-form-textarea
              v-model="model.description"
              rows="3"
              max-rows="3"
            ></b-form-textarea>
          </b-form-group>
          <ValidationProvider
            name="name"
            rules="required"
            v-slot="{ dirty, validated, valid, errors }"
          >
            <b-form-group label="Duration (minutes)">
              <b-form-input
                v-model="model.baseDuration"
                type="number"
                :min="1"
                pattern="^\d+$"
                :state="dirty || validated ? valid : null"
                required
              />
              <b-form-invalid-feedback>
                {{ errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </ValidationProvider>
          <b-form-group>
            <b-form-checkbox v-model="model.enabled">
              Currently Available
            </b-form-checkbox>
          </b-form-group>
          <b-form-group>
            <b-form-checkbox v-model="model.hidden">
              Hidden from Customers
            </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col xs="12" md="3">
          <h5>Packages</h5>
        </b-col>
        <b-col xs="12" md="6">
          <b-row
            v-for="_package in packages"
            :key="_package._id"
            class="mb-3"
            align-v="center"
          >
            <b-col md="6">
              <b-form-group>
                <b-form-checkbox
                  v-model="model.packagesEnabled[_package._id]"
                  class="form-check-inline"
                >
                  {{ _package.name }}
                </b-form-checkbox>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-input-group prepend="€">
                <b-form-input
                  v-model="model.pricesForPackages[_package._id]"
                  type="number"
                  :min="0"
                  :step="1"
                  placeholder="Enter a price"
                  :disabled="!model.packagesEnabled[_package._id]"
                  required
                />
              </b-input-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col xs="12" md="3">
          <h5>Barbers</h5>
        </b-col>
        <b-col xs="12" md="6">
          <div v-for="resource in resources" :key="resource._id">
            <b-form-group>
              <b-form-checkbox
                v-model="model.resourcesEnabled[resource._id]"
                class="form-check-inline"
              >
                {{ resource.name }}
              </b-form-checkbox>
            </b-form-group>
          </div>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col md="6" offset-md="3">
          <b-button variant="primary" type="submit">
            <b-spinner
              v-if="saving"
              variant="light"
              aria-label="Saving"
              style="height: 20px; width: 20px"
            ></b-spinner>
            <span v-else>Save</span>
          </b-button>
          <router-link tag="a" class="btn" :to="{ name: 'services' }">
            Cancel
          </router-link>
        </b-col>
      </b-row>
    </b-form>
  </ValidationObserver>
</template>
<script>
import _ from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import { ValidationProvider, ValidationObserver } from 'vee-validate';

const DEFAULT_SERVICE = {
  name: null,
  description: null,
  enabled: true,
  hidden: false,
  baseDuration: 0,
  packagesEnabled: {},
  pricesForPackages: {},
  resourcesEnabled: {}
};

export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  props: {
    service: {
      type: Object,
      default: () => DEFAULT_SERVICE
    },
    saving: Boolean
  },
  data() {
    return {
      model: DEFAULT_SERVICE,
      error: null
    };
  },
  methods: {
    ...mapActions({
      fetchResources: 'resources/fetchResources',
      fetchPackages: 'packages/fetchPackages'
    }),
    submit() {
      const model = {
        ...this.model,
        baseDuration: parseInt(this.model.baseDuration)
      };

      this.$emit('submit', model);
    },
    setModel(value) {
      this.model = _.cloneDeep(value);
    },
    setError(error) {
      this.error = error;
    }
  },
  computed: mapGetters({
    resources: 'resources/resourcesList',
    packages: 'packages/packagesList'
  }),
  async created() {
    try {
      await this.fetchResources();
      await this.fetchPackages();
      this.setModel(this.service);
    } catch (e) {
      this.setError(e.message);
    }
  }
};
</script>
